module.exports = __webpack_public_path__ + "static/media/TrendUp.6358da99.svg";